// ============================================
// Base de datos de marcas, modelos y eficiencia
// Top 100+ marcas — mercado global / RD
// ============================================

// Eficiencia de fábrica en km/L (promedio ciudad/carretera)
export const FUEL_EFFICIENCY = {
  'Toyota': {
    'Corolla': 14.5, 'Camry': 13.2, 'RAV4': 12.8, 'Hilux': 10.5,
    'Land Cruiser': 7.5, 'Prado': 8.5, 'Yaris': 16.0, 'Rush': 12.0,
    'Fortuner': 9.5, 'Tacoma': 10.0, '4Runner': 9.0, 'C-HR': 14.0,
    'Highlander': 10.5, 'Venza': 11.5, 'Tundra': 8.5, 'Supra': 11.0
  },
  'Honda': {
    'Civic': 14.5, 'Accord': 13.0, 'CR-V': 12.5, 'HR-V': 13.5,
    'Fit': 17.0, 'City': 15.5, 'Pilot': 10.0, 'Odyssey': 10.5, 'BR-V': 13.0
  },
  'Hyundai': {
    'Tucson': 12.5, 'Santa Fe': 11.0, 'Elantra': 14.5, 'Sonata': 13.5,
    'Accent': 15.5, 'Creta': 13.5, 'Venue': 14.0, 'Palisade': 9.5,
    'Kona': 14.0, 'Grand i10': 17.0, 'Starex': 9.0
  },
  'Kia': {
    'Sportage': 12.5, 'Seltos': 13.5, 'Forte': 14.5, 'Rio': 15.5,
    'Sorento': 11.0, 'Carnival': 9.5, 'Soul': 13.0, 'Picanto': 18.0,
    'K5': 13.5, 'Telluride': 9.5
  },
  'Nissan': {
    'Sentra': 14.5, 'Altima': 13.0, 'Pathfinder': 10.0, 'Frontier': 10.5,
    'Kicks': 14.0, 'Versa': 15.5, 'X-Trail': 12.0, 'Qashqai': 13.0,
    'Murano': 10.5, 'Rogue': 12.5
  },
  'Mitsubishi': {
    'Outlander': 12.0, 'ASX': 12.5, 'L200': 10.0, 'Montero Sport': 9.5,
    'Eclipse Cross': 12.0, 'Mirage': 18.5, 'Xpander': 13.0
  },
  'Suzuki': {
    'Vitara': 13.5, 'Swift': 17.0, 'Jimny': 12.5, 'S-Cross': 13.0,
    'Ertiga': 14.0, 'Baleno': 16.0, 'Grand Vitara': 13.0
  },
  'Chevrolet': {
    'Spark': 17.5, 'Cruze': 13.5, 'Equinox': 11.5, 'Traverse': 10.0,
    'Tahoe': 8.5, 'Suburban': 8.0, 'Silverado': 9.5, 'Colorado': 10.5,
    'Trax': 12.5, 'Blazer': 11.0, 'Captiva': 11.5
  },
  'Ford': {
    'Ranger': 10.5, 'Explorer': 10.0, 'Escape': 12.0, 'F-150': 9.0,
    'Expedition': 8.5, 'Edge': 11.0, 'Bronco': 10.0, 'EcoSport': 12.5,
    'Maverick': 12.5, 'Mustang': 10.5
  },
  'Jeep': {
    'Wrangler': 9.0, 'Grand Cherokee': 10.0, 'Cherokee': 11.0,
    'Compass': 12.0, 'Renegade': 12.5, 'Gladiator': 9.5
  },
  'Mazda': {
    'CX-5': 13.0, 'CX-30': 14.0, 'CX-3': 14.5, 'CX-9': 10.5,
    'Mazda3': 15.0, 'Mazda6': 13.5, 'BT-50': 10.0
  },
  'BMW': {
    'Serie 1': 14.0, 'Serie 2': 13.5, 'Serie 3': 13.0, 'Serie 4': 12.5,
    'Serie 5': 11.5, 'Serie 7': 9.5, 'X1': 13.0, 'X2': 13.0,
    'X3': 11.5, 'X4': 11.0, 'X5': 10.0, 'X6': 9.5, 'X7': 9.0, 'Z4': 12.0
  },
  'Mercedes-Benz': {
    'Clase A': 14.0, 'Clase B': 14.5, 'Clase C': 12.5, 'Clase E': 11.0,
    'Clase S': 9.5, 'CLA': 13.5, 'GLA': 12.0, 'GLB': 12.0,
    'GLC': 11.0, 'GLE': 10.0, 'GLS': 9.0, 'AMG GT': 8.5
  },
  'Audi': {
    'A1': 15.0, 'A3': 14.5, 'A4': 13.0, 'A5': 12.5, 'A6': 11.5,
    'A7': 11.0, 'A8': 10.0, 'Q2': 14.0, 'Q3': 13.0, 'Q5': 12.0,
    'Q7': 10.5, 'Q8': 10.0, 'TT': 13.0, 'R8': 8.5
  },
  'Volkswagen': {
    'Polo': 15.5, 'Golf': 14.5, 'Jetta': 14.0, 'Passat': 13.0,
    'Arteon': 12.5, 'T-Cross': 13.5, 'Taos': 13.0, 'Tiguan': 12.0,
    'Atlas': 10.0, 'Amarok': 10.5, 'ID.4': 0
  },
  'Porsche': {
    'Cayenne': 9.5, 'Macan': 11.5, 'Panamera': 10.0, '911': 10.5,
    'Taycan': 0, 'Boxster': 11.5, 'Cayman': 12.0
  },
  'Lexus': {
    'IS': 12.5, 'ES': 13.0, 'GS': 11.5, 'LS': 9.5, 'UX': 15.0,
    'NX': 13.0, 'RX': 11.5, 'GX': 9.0, 'LX': 7.5, 'LC': 10.0
  },
  'Dodge': {
    'Durango': 9.5, 'Charger': 10.5, 'Challenger': 10.0,
    'Ram 1500': 9.0, 'Ram 2500': 8.0, 'Journey': 11.0
  },
  'Renault': {
    'Kwid': 17.5, 'Logan': 15.0, 'Sandero': 15.5, 'Duster': 13.0,
    'Captur': 13.5, 'Koleos': 11.5, 'Oroch': 12.5
  },
  'Peugeot': {
    '208': 16.0, '301': 15.0, '308': 14.5, '2008': 14.0,
    '3008': 13.0, '5008': 12.0, 'Partner': 13.0
  },
  'Chery': {
    'Tiggo 2': 14.5, 'Tiggo 3': 13.5, 'Tiggo 4': 13.0, 'Tiggo 5X': 12.5,
    'Tiggo 7': 12.0, 'Tiggo 8': 11.5, 'Arrizo 5': 14.0
  },
  'MG': {
    'MG3': 15.5, 'ZS': 14.0, 'HS': 12.5, 'MG5': 14.5, 'RX5': 13.0
  },
  'Subaru': {
    'Impreza': 14.0, 'Legacy': 13.5, 'Forester': 12.5, 'Outback': 12.5,
    'Crosstrek': 14.0, 'WRX': 11.5, 'BRZ': 13.0, 'Ascent': 10.5
  },
};

export function getManufacturerEfficiency(brand, model) {
  return FUEL_EFFICIENCY[brand]?.[model] || null;
}

export const VEHICLE_MAKES = {
  // ── Japonesas ──────────────────────────────────────────────────────────────
  'Toyota': [
    'Camry', 'Corolla', 'RAV4', 'Hilux', 'Land Cruiser', 'Prado',
    'Yaris', 'Rush', 'Fortuner', 'Tacoma', '4Runner', 'Supra',
    'C-HR', 'Avalon', 'Tundra', 'Sequoia', 'Highlander', 'Venza',
    'FJ Cruiser', 'bZ4X'
  ],
  'Honda': [
    'Accord', 'Civic', 'CR-V', 'HR-V', 'Fit', 'City',
    'Pilot', 'Odyssey', 'Ridgeline', 'Passport', 'BR-V',
    'ZR-V', 'e:Ny1'
  ],
  'Nissan': [
    'Altima', 'Sentra', 'Versa', 'Maxima', 'Kicks', 'Frontier',
    'Pathfinder', 'X-Trail', 'Qashqai', 'Murano', 'Rogue',
    'Armada', 'Titan', 'NP300', 'Navara', 'Patrol',
    'GT-R', '370Z', '400Z'
  ],
  'Mazda': [
    'Mazda2', 'Mazda3', 'Mazda6', 'CX-3', 'CX-30', 'CX-5',
    'CX-50', 'CX-9', 'MX-5 Miata', 'MX-30', 'BT-50'
  ],
  'Mitsubishi': [
    'Mirage', 'Lancer', 'Eclipse Cross', 'Outlander', 'ASX',
    'L200', 'Montero', 'Montero Sport', 'Xpander', 'Pajero'
  ],
  'Suzuki': [
    'Alto', 'Celerio', 'Baleno', 'Swift', 'S-Cross', 'Vitara',
    'Grand Vitara', 'Jimny', 'Ertiga', 'XL7', 'Carry'
  ],
  'Subaru': [
    'Impreza', 'Legacy', 'Outback', 'Forester', 'Crosstrek',
    'WRX', 'BRZ', 'Ascent', 'Solterra'
  ],
  'Lexus': [
    'IS', 'ES', 'GS', 'LS', 'UX', 'NX', 'RX', 'GX', 'LX', 'LC', 'RC'
  ],
  'Acura': [
    'ILX', 'TLX', 'RLX', 'MDX', 'RDX', 'NSX', 'Integra'
  ],
  'Infiniti': [
    'Q50', 'Q60', 'Q70', 'QX30', 'QX50', 'QX55', 'QX60', 'QX80'
  ],
  'Isuzu': [
    'D-Max', 'MU-X', 'Trooper', 'Rodeo', 'Amigo'
  ],

  // ── Coreanas ───────────────────────────────────────────────────────────────
  'Hyundai': [
    'Grand i10', 'i10', 'i20', 'i30', 'Accent', 'Elantra', 'Sonata',
    'Azera', 'Venue', 'Kona', 'Creta', 'Tucson', 'Santa Fe', 'Palisade',
    'Starex', 'H-1', 'Ioniq', 'Ioniq 5', 'Ioniq 6', 'Staria'
  ],
  'Kia': [
    'Picanto', 'Rio', 'Stonic', 'Soul', 'Forte', 'K5', 'K8', 'Stinger',
    'Seltos', 'Sportage', 'Sorento', 'Telluride', 'Carnival', 'Niro', 'EV6'
  ],
  'SsangYong': [
    'Tivoli', 'Korando', 'Rexton', 'Musso', 'Torres'
  ],

  // ── Americanas ─────────────────────────────────────────────────────────────
  'Ford': [
    'Fiesta', 'Focus', 'Fusion', 'Mustang', 'EcoSport', 'Escape',
    'Edge', 'Explorer', 'Expedition', 'Bronco', 'Bronco Sport',
    'Maverick', 'Ranger', 'F-150', 'F-250', 'F-350', 'Transit', 'Transit Connect'
  ],
  'Chevrolet': [
    'Aveo', 'Spark', 'Onix', 'Cruze', 'Malibu', 'Camaro', 'Corvette',
    'Trax', 'Trailblazer', 'Equinox', 'Blazer', 'Traverse', 'Captiva',
    'Tahoe', 'Suburban', 'Colorado', 'Silverado', 'Avalanche', 'Kodiak'
  ],
  'Dodge': [
    'Neon', 'Dart', 'Charger', 'Challenger', 'Durango',
    'Journey', 'Grand Caravan', 'Ram 1500', 'Ram 2500', 'Ram 3500'
  ],
  'Ram': [
    '1500', '2500', '3500', 'ProMaster', 'ProMaster City'
  ],
  'Jeep': [
    'Renegade', 'Compass', 'Cherokee', 'Grand Cherokee', 'Grand Cherokee L',
    'Wrangler', 'Gladiator', 'Wagoneer', 'Grand Wagoneer'
  ],
  'Chrysler': [
    '200', '300', 'Pacifica', 'Voyager'
  ],
  'Cadillac': [
    'CT4', 'CT5', 'XT4', 'XT5', 'XT6', 'Escalade', 'Lyriq'
  ],
  'GMC': [
    'Terrain', 'Envoy', 'Acadia', 'Yukon', 'Yukon XL', 'Sierra', 'Canyon'
  ],
  'Buick': [
    'Encore', 'Encore GX', 'Envision', 'Enclave', 'LaCrosse'
  ],
  'Lincoln': [
    'Corsair', 'Nautilus', 'Aviator', 'Navigator', 'Continental'
  ],
  'Tesla': [
    'Model 3', 'Model S', 'Model X', 'Model Y', 'Cybertruck'
  ],

  // ── Alemanas ───────────────────────────────────────────────────────────────
  'BMW': [
    'Serie 1', 'Serie 2', 'Serie 3', 'Serie 4', 'Serie 5', 'Serie 6',
    'Serie 7', 'Serie 8', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7',
    'Z3', 'Z4', 'M2', 'M3', 'M4', 'M5', 'iX', 'i4', 'i7'
  ],
  'Mercedes-Benz': [
    'Clase A', 'Clase B', 'Clase C', 'Clase E', 'Clase S',
    'CLA', 'CLS', 'GLA', 'GLB', 'GLC', 'GLE', 'GLS',
    'G-Class', 'AMG GT', 'Sprinter', 'Vito', 'EQC', 'EQS', 'EQE'
  ],
  'Audi': [
    'A1', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8',
    'Q2', 'Q3', 'Q4 e-tron', 'Q5', 'Q7', 'Q8',
    'TT', 'R8', 'RS3', 'RS4', 'RS5', 'RS6', 'RS7', 'e-tron'
  ],
  'Volkswagen': [
    'Polo', 'Golf', 'Golf GTI', 'Golf R', 'Jetta', 'Passat', 'Arteon',
    'T-Cross', 'Taos', 'Tiguan', 'Touareg', 'Atlas', 'Amarok',
    'Transporter', 'Caddy', 'ID.3', 'ID.4', 'ID.5'
  ],
  'Porsche': [
    '911', '911 Carrera', '911 Turbo', '911 GT3',
    'Boxster', 'Cayman', '718 Boxster', '718 Cayman',
    'Macan', 'Cayenne', 'Cayenne GTS', 'Cayenne Turbo',
    'Panamera', 'Taycan'
  ],
  'Opel': [
    'Corsa', 'Astra', 'Insignia', 'Mokka', 'Crossland', 'Grandland', 'Zafira'
  ],

  // ── Italianas ──────────────────────────────────────────────────────────────
  'Ferrari': [
    'Roma', 'Portofino', 'SF90', 'F8', '296 GTB', 'GTC4Lusso', 'Purosangue'
  ],
  'Lamborghini': [
    'Huracán', 'Urus', 'Revuelto'
  ],
  'Maserati': [
    'Ghibli', 'Quattroporte', 'Levante', 'Grecale', 'GranTurismo', 'MC20'
  ],
  'Alfa Romeo': [
    'Giulia', 'Stelvio', 'Tonale', 'Giulietta', 'MiTo', '4C'
  ],
  'Fiat': [
    'Pulse', 'Fastback', '500', '500X', 'Tipo', 'Doblo', 'Punto', 'Toro', 'Mobi'
  ],

  // ── Francesas ──────────────────────────────────────────────────────────────
  'Peugeot': [
    '208', '301', '308', '408', '508', '2008', '3008', '5008', 'Partner', 'Rifter', 'Landtrek'
  ],
  'Renault': [
    'Kwid', 'Logan', 'Sandero', 'Duster', 'Stepway', 'Oroch',
    'Captur', 'Koleos', 'Megane', 'Clio', 'Arkana', 'Austral'
  ],
  'Citroën': [
    'C3', 'C3 Aircross', 'C4', 'C4 Cactus', 'C5 Aircross', 'Berlingo', 'Jumper'
  ],
  'DS': [
    'DS3', 'DS4', 'DS7', 'DS9'
  ],

  // ── Británicas ─────────────────────────────────────────────────────────────
  'Land Rover': [
    'Defender', 'Discovery', 'Discovery Sport', 'Freelander',
    'Range Rover', 'Range Rover Sport', 'Range Rover Evoque', 'Range Rover Velar'
  ],
  'Jaguar': [
    'XE', 'XF', 'XJ', 'E-Pace', 'F-Pace', 'I-Pace', 'F-Type'
  ],
  'MINI': [
    'Cooper', 'Cooper S', 'Convertible', 'Clubman', 'Countryman', 'Paceman', 'Pacesetter'
  ],
  'Bentley': [
    'Continental GT', 'Flying Spur', 'Bentayga', 'Mulsanne'
  ],
  'Rolls-Royce': [
    'Ghost', 'Phantom', 'Wraith', 'Dawn', 'Cullinan', 'Spectre'
  ],
  'McLaren': [
    'Artura', '570S', '720S', '765LT', 'GT', 'Senna'
  ],
  'Aston Martin': [
    'DB11', 'DBS', 'Vantage', 'Rapide', 'DBX'
  ],

  // ── Suecas ─────────────────────────────────────────────────────────────────
  'Volvo': [
    'S60', 'S90', 'V60', 'V90', 'XC40', 'XC60', 'XC90', 'C40', 'EX40'
  ],

  // ── Chinas ─────────────────────────────────────────────────────────────────
  'Chery': [
    'QQ', 'Arrizo 5', 'Arrizo 6', 'Tiggo 2', 'Tiggo 3', 'Tiggo 4',
    'Tiggo 5X', 'Tiggo 7', 'Tiggo 8', 'Tiggo 8 Pro'
  ],
  'MG': [
    'MG3', 'MG5', 'ZS', 'ZS EV', 'HS', 'Marvel R', 'RX5', 'Cyberster'
  ],
  'JAC': [
    'S2', 'S3', 'S4', 'S7', 'T6', 'T8', 'Sei4', 'J7'
  ],
  'DFSK': [
    'Glory 560', 'Glory 580', 'Glory 600', 'Seres 3', 'K01', 'C35', 'C37'
  ],
  'BYD': [
    'Seal', 'Atto 3', 'Han', 'Tang', 'Song', 'Yuan Plus', 'Dolphin', 'Shark'
  ],
  'Haval': [
    'H2', 'H4', 'H6', 'H9', 'Jolion', 'Dargo', 'Big Dog'
  ],
  'Great Wall': [
    'Poer', 'Cannon', 'Tank 300', 'Tank 500'
  ],
  'Geely': [
    'Emgrand', 'Coolray', 'Azkarra', 'Okavango', 'Tugella'
  ],
  'Changan': [
    'Alsvin', 'Eado', 'CS35', 'CS55', 'CS75', 'CS95', 'Hunter'
  ],
  'Omoda': [
    'C5', 'C9'
  ],
  'BAIC': [
    'BJ40', 'X25', 'X35', 'X55', 'BJ212'
  ],
  'Foton': [
    'Tunland', 'Gratour', 'View'
  ],
  'Dongfeng': [
    'Rich 6', 'AX5', 'SX6'
  ],
  'Maxus': [
    'T60', 'T90', 'D90', 'G10'
  ],

  // ── Indias ─────────────────────────────────────────────────────────────────
  'Mahindra': [
    'Scorpio', 'Bolero', 'XUV300', 'XUV500', 'XUV700', 'Thar', 'Pik Up'
  ],
  'Tata': [
    'Nexon', 'Harrier', 'Safari', 'Punch', 'Tigor', 'Altroz'
  ],

  // ── Otras / Clásicas ───────────────────────────────────────────────────────
  'Daihatsu': [
    'Terios', 'Sirion', 'Rocky', 'Hijet', 'Move'
  ],
  'Pontiac': [
    'Grand Am', 'Grand Prix', 'Bonneville', 'Montana', 'Aztek', 'G6'
  ],
  'Oldsmobile': [
    'Alero', 'Aurora', 'Bravada', 'Cutlass', 'Intrigue', 'Silhouette'
  ],
  'Saturn': [
    'Ion', 'Vue', 'Aura', 'Outlook'
  ],
  'Hummer': [
    'H1', 'H2', 'H3'
  ],
  'Saab': [
    '9-3', '9-5', '9-7X'
  ],
  'Lancia': [
    'Delta', 'Ypsilon', 'Thesis'
  ],
  'Seat': [
    'Ibiza', 'León', 'Arona', 'Ateca', 'Tarraco', 'Mii'
  ],
  'Skoda': [
    'Fabia', 'Octavia', 'Superb', 'Kamiq', 'Karoq', 'Kodiaq', 'Scala', 'Enyaq'
  ],
  'Cupra': [
    'Formentor', 'Born', 'Ateca', 'Leon'
  ],
  'Dacia': [
    'Sandero', 'Logan', 'Duster', 'Spring', 'Jogger', 'Bigster'
  ],
  'Polestar': [
    '2', '3', '4'
  ],
  'Rivian': [
    'R1T', 'R1S'
  ],
  'Lucid': [
    'Air'
  ],
  'Genesis': [
    'G70', 'G80', 'G90', 'GV70', 'GV80', 'GV60'
  ],
  'Otro': []
};

// ── Vehículos comerciales / trabajo ───────────────────────────────────────────
export const COMMERCIAL_MAKES = {
  // Autobuses / Minibuses
  'Hyundai (Bus)': [
    'County', 'Aero Town', 'Aero City', 'Super Aero City', 'Universe', 'Mega Space'
  ],
  'Toyota (Bus)': [
    'Coaster', 'HiAce (Bus)', 'Land Cruiser (Bus)'
  ],
  'King Long': [
    'XMQ6900', 'XMQ6127', 'XMQ6129', 'XMQ6800', 'XMQ6119'
  ],
  'Yutong': [
    'ZK6129H', 'ZK6109H', 'ZK6899H', 'ZK6127H', 'ZK6938H'
  ],
  'Higer': [
    'KLQ6119', 'KLQ6109', 'KLQ6928', 'KLQ6856'
  ],
  'Golden Dragon': [
    'XML6127', 'XML6109', 'XML6900', 'XML6796'
  ],
  'Zhongtong': [
    'LCK6127H', 'LCK6109H', 'LCK6808H'
  ],
  'Mercedes-Benz (Bus)': [
    'OF-1721', 'OF-1419', 'Citaro', 'Conecto', 'Sprinter (Bus)'
  ],
  'Volvo (Bus)': [
    'B7R', 'B9R', 'B11R', '7900', '9700', '9900'
  ],
  'Scania (Bus)': [
    'K310', 'K380', 'K410', 'F310', 'Irizar'
  ],

  // Camiones ligeros / Furgonetas
  'Isuzu (Camión)': [
    'NKR', 'NLR', 'NMR', 'FRR', 'FSR', 'FTR', 'FVR', 'FVM', 'Elf'
  ],
  'Hino': [
    '300 Series', '500 Series', '700 Series', 'XZU', 'FC', 'FD', 'FE', 'FF', 'SG', 'SS', 'ZM'
  ],
  'Mitsubishi Fuso': [
    'Canter', 'Fighter', 'Heavy', 'Super Great', 'Rosa (Minibus)'
  ],
  'UD Trucks': [
    'Quon', 'Condor', 'Croner', 'Kazet'
  ],
  'Nissan (Camión)': [
    'Cabstar', 'Atlas', 'Diesel'
  ],
  'Toyota (Camión)': [
    'Dyna', 'HiAce Cargo', 'Land Cruiser 79'
  ],

  // Camiones pesados
  'Freightliner': [
    'Cascadia', 'Columbia', 'Century', 'Coronado', 'Business Class M2', 'Sprinter'
  ],
  'Kenworth': [
    'T680', 'T880', 'W900', 'T370', 'T270', 'C500'
  ],
  'Peterbilt': [
    '389', '579', '567', '520', '337'
  ],
  'International': [
    'LT Series', 'HV Series', 'MV Series', 'HX Series', 'CV Series'
  ],
  'Mack': [
    'Anthem', 'Pinnacle', 'Granite', 'TerraPro', 'LR'
  ],
  'Volvo (Camión)': [
    'FH', 'FM', 'FMX', 'FE', 'FL', 'VNL', 'VHD', 'VAH'
  ],
  'Scania (Camión)': [
    'R Series', 'S Series', 'P Series', 'G Series', 'L Series'
  ],
  'Mercedes-Benz (Camión)': [
    'Actros', 'Arocs', 'Antos', 'Atego', 'Axor', 'Vario'
  ],
  'DAF': [
    'XF', 'CF', 'LF', 'XG'
  ],
  'MAN': [
    'TGX', 'TGS', 'TGM', 'TGL', 'Lion\'s Coach'
  ],

  // Vans / Furgonetas de trabajo
  'Ford (Van)': [
    'Transit', 'Transit Connect', 'Transit Custom', 'E-350', 'E-450'
  ],
  'Mercedes-Benz (Van)': [
    'Sprinter', 'Vito', 'Viano', 'Metris', 'Citan'
  ],
  'Volkswagen (Van)': [
    'Transporter T5', 'Transporter T6', 'Crafter', 'Caddy Cargo', 'Multivan'
  ],
  'RAM (Van)': [
    'ProMaster', 'ProMaster City', 'ProMaster Window Van'
  ],
  'Chevrolet (Van)': [
    'Express', 'G-Series', 'City Express'
  ],

  // Maquinaria / Equipos especiales
  'Caterpillar': [
    'Excavadora 320', 'Excavadora 330', 'Motoniveladora 120', 'Buldócer D6',
    'Compactador CS56', 'Cargadora 966', 'Retroexcavadora 420'
  ],
  'Komatsu': [
    'PC200', 'PC300', 'PC400', 'WA320', 'WA380', 'D65', 'GD655'
  ],
  'John Deere': [
    '310', '410', '710', '544', '644', 'Tractor 5055E', 'Tractor 6120R'
  ],
  'Bobcat': [
    'S570', 'S590', 'S650', 'T76', 'E35', 'E50', 'E85'
  ],
  'Hyundai (Maquinaria)': [
    'R140LC', 'R170W', 'R210LC', 'HL740', 'HL760'
  ],
  'Volvo (Maquinaria)': [
    'EC140E', 'EC220E', 'EC350E', 'L70H', 'L90H', 'G930'
  ],
};

// Tipos de vehículo para filtrar UI y categorizar alertas/productos
export const VEHICLE_TYPES = [
  { value: 'auto',       label: '🚗 Auto / Sedan' },
  { value: 'suv',        label: '🚙 SUV / Jeepeta' },
  { value: 'pickup',     label: '🛻 Pickup' },
  { value: 'van',        label: '🚐 Van / Furgoneta' },
  { value: 'minibus',    label: '🚌 Minibús / Guagua pequeña' },
  { value: 'bus',        label: '🚌 Autobús / Guagua grande' },
  { value: 'camion',     label: '🚛 Camión ligero' },
  { value: 'camion_pes', label: '🚚 Camión pesado / Trailer' },
  { value: 'moto',       label: '🏍️ Motocicleta' },
  { value: 'maquinaria', label: '🏗️ Maquinaria / Equipo especial' },
  { value: 'otro',       label: '🚘 Otro' },
];

// Intervalos de cambio de aceite en meses (opciones para el usuario)
export const OIL_INTERVAL_OPTIONS = [
  { value: 2,  label: 'Cada 2 meses (uso intensivo / trabajo)' },
  { value: 3,  label: 'Cada 3 meses' },
  { value: 4,  label: 'Cada 4 meses (recomendado)' },
  { value: 6,  label: 'Cada 6 meses' },
  { value: 12, label: 'Una vez al año' },
];

export const MAKE_LIST = Object.keys(VEHICLE_MAKES).sort((a, b) => {
  if (a === 'Otro') return 1;
  if (b === 'Otro') return -1;
  return a.localeCompare(b);
});

export const COMMERCIAL_MAKE_LIST = Object.keys(COMMERCIAL_MAKES).sort();

// ── Motocicletas / pasolas / scooters (mercado RD) ──────────────────────────
// En RD las marcas chinas/locales se venden por "tipo + cc" (CG 150, GN 125…)
// más que por modelo oficial. Estas opciones genéricas cubren ese mundo.
const MOTO_GENERIC_MODELS = [
  'CG 110', 'CG 125', 'CG 150', 'CG 200', 'CG 250',
  'GN 125', 'GN 150', 'GN 200',
  'GS 125', 'GS 150',
  '110', '125', '150', '200', '250', '300',
  'Cross 150', 'Cross 200', 'Sport 150', 'Sport 200',
];

export const MOTO_MAKES = {
  'Honda': [
    'CG 125', 'CG 150', 'CGL 125', 'Wave 110', 'Navi', 'XR 150L', 'XR 190L',
    'CRF 250', 'CB 125', 'CB 190R', 'Dio', 'Elite 125', 'Cargo 150', 'Biz 125'
  ],
  'Yamaha': [
    'YBR 125', 'Crypton 110', 'FZ 150', 'FZ 250', 'XTZ 125', 'XTZ 150',
    'XTZ 250', 'BWS 125', 'Cygnus', 'MT-03', 'YZF R3', 'Crux'
  ],
  'Suzuki': [
    'AX 100', 'GN 125', 'GS 125', 'EN 125', 'Best 125', 'GD 110', 'GSX 150',
    'Gixxer 150', 'DR 150', 'V-Strom 150'
  ],
  'Bajaj': [
    'Boxer CT 100', 'Boxer 150', 'Pulsar 135', 'Pulsar 150', 'Pulsar 180',
    'Pulsar NS 160', 'Pulsar NS 200', 'Platina 100', 'Discover 125', 'CT 110'
  ],
  'SYM': [
    'Symba 100', 'Jet 14', 'Crox 125', 'Orbit 125', 'Symphony 150', 'NH-T 125'
  ],
  'Italika': [
    'FT 125', 'FT 150', 'DM 150', 'GS 150', 'AT 110', 'RT 200', 'Vitalia 125'
  ],
  'Loncin': ['GP 150', 'JL 150', 'LX 110', 'Falcon 250', ...MOTO_GENERIC_MODELS],
  'Keeway': ['RKV 125', 'RKV 200', 'TX 200', 'Superlight 200', 'K-Light 125'],
  'Bera': ['BR 150', 'SBR 200', 'Socialista', 'BX 150', 'Brava 200', ...MOTO_GENERIC_MODELS],
  'Tauro': [...MOTO_GENERIC_MODELS],
  'TVS': ['Apache RTR 160', 'Apache RTR 200', 'Star City', 'HLX 125', 'Sport 100'],
  'Hero': ['Hunk 150', 'Dash 110', 'Eco Deluxe', 'Ignitor 125', 'Xpulse 200'],
  'Genesis': ['GNX 150', 'Fox 110', 'Wind 200', ...MOTO_GENERIC_MODELS],
  'Haojue': ['DK 150', 'TR 150', 'Lindy 125', 'KA 110', ...MOTO_GENERIC_MODELS],
  'Kymco': ['Agility 125', 'Like 150', 'Super 8'],
  'CFMoto': ['250 NK', '300 NK', '650 NK'],
  'Benelli': ['TNT 135', 'TNT 150', '302S', 'Leoncino 250'],
  'KTM': ['Duke 125', 'Duke 200', 'Duke 250', 'RC 200'],
  'Kawasaki': ['Ninja 250', 'Ninja 400', 'Z250', 'KLX 150'],
  'Vespa': ['Primavera 150', 'Sprint 150', 'GTS 300'],
  'Royal Enfield': ['Classic 350', 'Meteor 350', 'Hunter 350'],
  'Harley-Davidson': ['Street 750', 'Iron 883', 'Sportster'],
  'Genérica / China': [...MOTO_GENERIC_MODELS],
  'Otro': [],
};

export const MOTO_MAKE_LIST = Object.keys(MOTO_MAKES).sort((a, b) => {
  if (a === 'Otro') return 1;
  if (b === 'Otro') return -1;
  return a.localeCompare(b);
});

// Coarse: ¿es motocicleta/pasola/scooter? (todo cae bajo vehicleType 'moto')
export function isMotorcycle(vehicle) {
  return (vehicle?.vehicleType || '') === 'moto';
}

export const YEAR_LIST = [
  ...Array.from(
    { length: new Date().getFullYear() - 1985 + 2 },
    (_, i) => String(new Date().getFullYear() + 1 - i)
  ),
  'Vintage (antes de 1985)',
];
